export const scrollToId = (id, behavior = "smooth") => {
  const reduce =
    typeof window !== "undefined" &&
    window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  const target = typeof id === "string" ? document.querySelector(id) : id;
  if (!target) return;
  const top = target.getBoundingClientRect().top + window.pageYOffset - 72;
  window.scrollTo({ top, behavior: reduce ? "auto" : behavior });
};

export const scrollToTop = () => {
  const reduce =
    typeof window !== "undefined" &&
    window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
};
